import { createRoot } from "react-dom/client";
import "./styles/base.css";
import "./styles/chat.css";
import "./styles/admin.css";
import "./styles/kanban.css";
import "./styles/shortcuts.css";
import "./styles/settings.css";
import "./styles/automacao.css";
import "./styles/cadence.css";
import "./styles/shell.css";
import "./styles/overlays.css";
import "./styles/account-switcher.css";
import "./styles/jampack.css";
import "./styles/main.css";
import { App } from "./app/App.tsx";
import { AppProvider } from "./app/AppProvider.tsx";
import { ModalProvider } from "./components/ModalProvider.tsx";
import { ToastProvider } from "./components/ToastProvider.tsx";

const root = document.getElementById("app");

if (!root) {
  throw new Error("Missing #app root element");
}

createRoot(root).render(
  <AppProvider>
    <ToastProvider>
      <ModalProvider>
        <App />
      </ModalProvider>
    </ToastProvider>
  </AppProvider>,
);
